import { OverlayRef } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { CommonMessages } from '@frontend/vanilla/core';

import { BetstationLoginTrackingService } from './betstation-login-tracking.service';
import { BETSTATION_LOGIN_ERROR } from './betstation-login.models';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'vn-betstation-login-error-overlay',
    templateUrl: 'betstation-login-error-overlay.component.html',
})
export class BetstationLoginErrorOverlayComponent implements OnInit {
    commonMessages = inject(CommonMessages);
    private overlayRef = inject(OverlayRef);
    private trackingService = inject(BetstationLoginTrackingService);
    private error = inject(BETSTATION_LOGIN_ERROR);

    message: string;

    ngOnInit(): void {
        this.message = this.error;
        this.trackingService.trackErrorMessageShown(this.message);
    }

    close() {
        this.trackingService.trackErrorMessageOk(this.message);
        this.overlayRef.detach();
    }
}
